import { render } from "./TemplateOne.vue?vue&type=template&id=4d8593ac"
import script from "./TemplateOne.vue?vue&type=script&lang=js"
export * from "./TemplateOne.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__